export default __webpack_public_path__ + "static/media/unreal.e3eb696b.svg";